import { ReactElement } from 'react';

import FrontImage from '../../assets/images/LandingPage/frontImg.png';
import { QuotesForm } from '../../components/_organisms/QuotesForm';
import QuotesPageContent from '../../components/_organisms/QuotesPageContent';
import { NextPageWithLayout } from '../../components/layouts';
import LandingPageLayout from '../../components/layouts/LandingPageLayout';

const QuotesPage: NextPageWithLayout = () => {
  return <QuotesPageContent />;
};

QuotesPage.getLayout = function getLayout(page: ReactElement) {
  return (
    <LandingPageLayout
      title="Quotes"
      subTitle="How to get a quote"
      primaryActionText="Sign up - It's free"
      image={FrontImage}
      hideBlobs={false}
      disableHeadline={true}
    >
      <QuotesForm />
      {page}
    </LandingPageLayout>
  );
};

export default QuotesPage;
